export enum RosterStatus {
  PRECREATE = -1,
  DRAFT = 0,
  PENDING_APPROVAL,
  MOBILIZED,
  ACTIVATED,
  DEMOBILIZED,
  CLOSED,
}
